import React, { Component }  from "react"
import styled from 'styled-components'
import Slider from "react-slick"

import FiveStars from '../svgs/landing-page/five-stars.svg'
import GoogleLogo from '../images/google-logo.png'
import LongLeftArrow from '../images/white-arrow-left.svg'
import LongRightArrow from '../images/white-arrow-right.svg'

class LandingPageSlider extends Component {

    render() {

        const settings = {
            arrows: true,
            dots: false,
            infinite: true,
            autoplay: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
          };

          return (
            <SliderContent>
                <Slider {...settings}>
                    <div class="slide-main">
                        <div class="slide-top">
                            <div class="google-rating">
                                <p>5.0</p>
                                <FiveStars/>
                                <p>11 User Reviews</p>
                            </div>
                            <img src={GoogleLogo} alt="Google Logo" width="100" height="34" />
                        </div>
                        <div class="slide-copy">
                            <p>White Lion did a fantastic job working remotely with our communications team. They provided great feedback and ideas every time. We were continually impressed with their graphic design and project management. Their team really listened to what we needed and hit it out of the park. Would definitely recommend them for future projects.</p>
                        </div>
                        <div class="slide-bottom">
                            <h3>Morgan D.</h3>
                            <h4>National Propane Gas Association</h4>
                        </div>
                    </div>
                    <div class="slide-main">
                        <div class="slide-top">
                            <div class="google-rating">
                                <p>5.0</p>
                                <FiveStars/>
                                <p>11 User Reviews</p>
                            </div>
                            <img src={GoogleLogo} alt="Google Logo" width="100" height="34" />
                        </div>
                        <div class="slide-copy">
                            <p>Creativity is hard. And it's subjective. Harder still, as a business, is finding a multiskilled, multifaceted creative agency that aligns with your values and culture; one that pushes you and is comfortable with being pushed, all driving towards a common goal. If you can find them - through that grueling process that we're all familiar with - you've struck gold. Our firm has found just that in White Lion Interactive.</p>
                        </div>
                        <div class="slide-bottom">
                            <h3>Kenneth Holley</h3>
                            <h4>Silent Quadrant</h4>
                        </div>
                    </div>
                    <div class="slide-main">
                        <div class="slide-top">
                            <div class="google-rating">
                                <p>5.0</p>
                                <FiveStars/>
                                <p>11 User Reviews</p>
                            </div>
                            <img src={GoogleLogo} alt="Google Logo" width="100" height="34" />
                        </div>
                        <div class="slide-copy">
                            <p>White Lion has always been one of Yokogawa's most valued vendors. We have found no other team who can match the quality of their work, their attention to detail, or their quick turnaround times on requests.</p>
                        </div>
                        <div class="slide-bottom">
                            <h3>Wes Dulaney</h3>
                            <h4>Yokogawa</h4>
                        </div>
                    </div>
                    <div class="slide-main">
                        <div class="slide-top">
                            <div class="google-rating">
                                <p>5.0</p>
                                <FiveStars/>
                                <p>11 User Reviews</p>
                            </div>
                            <img src={GoogleLogo} alt="Google Logo" width="100" height="34" />
                        </div>
                        <div class="slide-copy">
                            <p>We have been leveraging WL for more than two years now and their quality and delivery of work is phenomenal. We have our global customer presence and have received very positive responses for our newly developed website. I highly encourage to leverage WL for web site development with advanced software tools & technologies available. I promise you will have a great experience working with them.</p>
                        </div>
                        <div class="slide-bottom">
                            <h3>Rajeev Sharma</h3>
                            <h4>Open Compute Project</h4>
                        </div>
                    </div>
                </Slider>
            </SliderContent>
          );
    }
}

const SliderContent = styled.section`
    width: 100%;
    margin: 20px auto;
    margin-bottom: 10px;
    padding: 0;
    .slick-prev {
        width: 50px;
        height: 50px;
        left: -25px;
        background-color: #db4140;
        background-image: url(${LongLeftArrow});
        background-size: 50%;
        background-position: center;
        background-repeat: no-repeat;
        color: transparent;
        z-index: 15;
        transition-duration: .3s;
        &:before {
            display: none;
        }
        &:hover {
          background-color: #2b2520;
          background-image: url(${LongLeftArrow});
        }
    }
      .slick-next {
          width: 50px;
          height: 50px;
          right: -25px;
          background-color: #db4140;
          background-image: url(${LongRightArrow});
          background-size: 50%;
          background-position: center;
          background-repeat: no-repeat;
          color: transparent;
          z-index: 15;
          transition-duration: .3s;
          &:before {
              display: none;
          }
          &:hover {
          background-color: #2b2520;
          background-image: url(${LongRightArrow});
          }
      }
    .slide-main {
        padding: 0 100px;
        outline: 0;
        .slide-top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .google-rating {
                display: flex;
                width: 300px;
                align-items: flex-end;
                p {
                    &:first-child {
                        font-family: "Work Sans";
                        font-size: 32px;
                        font-weight: 400;
                        line-height: 1.4;
                        color: rgb(236 112 26);
                        margin-bottom: 0px;
                    }
                    &:last-child {
                        font-family: "Work Sans";
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 1.4;
                        color: rgb(119, 124, 124);
                        margin-bottom: 8px;
                    }
                }
                svg {
                    width: 80px;
                    margin: 0 10px;
                    margin-bottom: 12px;
                }
            }
        }
        .slide-copy {
            background-color: #fff;
            position: relative;
            padding: 30px;
            margin-top: 5px;
            margin-bottom: 35px;
            p {
                font-family: "Work Sans";
                font-size: 16px;
                font-weight: 400;
                line-height: 1.4;
                color: rgb(119, 124, 124);
                margin-bottom: 0px;
            }
            &:after {
                content: '';
                position: absolute;
                height: 40px;
                width: 40px;
                bottom: -40px;
                left: calc( 50% - 20px );
                border-top: 30px solid #fff;
                border-left: 20px solid transparent;
                border-right: 20px solid transparent;
            }
        }
        .slide-bottom {
            text-align: center;
            h3 {
                text-align: center;
                font-family: Nobel, sans-serif;
                font-weight: 700;
                font-style: normal;
                font-size: 20px;
                margin-top: 0px;
                margin-bottom: 0px;
            }
            h4 {
                font-family: "Work Sans";
                font-size: 16px;
                font-weight: 400;
                line-height: 1.4;
                color: rgb(119, 124, 124);
                margin-bottom: 0px;
                margin-top: 0;
            }
        }
    }
    @media(max-width:1000px) {
      max-width: 700px;
    }
    @media(max-width:767px) {
      max-width: 500px;
      margin: 30px auto;
      .slick-prev {
          left: -35px;
      }
      .slick-next {
          right: -35px;
      }
      .slide-main {
          padding: 0;
          .slide-top {
              flex-direction: column;
              .google-rating {
                align-items: center;
                flex-direction: column;
                margin: 0 auto;
              }
              img {
                max-width: 60px;
                height: auto;
              }
          }
          .slide-copy {
              padding: 10px;
              p {
                font-size: 14px;
                padding: 10px;
              }
          }
      }
    }
`

export default LandingPageSlider